export default "__VITE_ASSET__DcLlbC3I__"